import React, { useState } from "react";
import { ReadMoreProps } from "../interfaces/ReadMore";

const ReadMoreComponent: React.FC<ReadMoreProps> = ({ text, maxLength }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const displayText = isExpanded ? text : text.slice(0, maxLength);

  return (
    <div>
      <p className=" text-[#546E7A]">
        {displayText}
        {text.length > maxLength && (
          <span
            onClick={toggleReadMore}
            className="text-[#037897] font-semibold"
          >
            {isExpanded ? " Read Less" : " Read More"}
          </span>
        )}
      </p>
    </div>
  );
};

export default ReadMoreComponent;
